import React from 'react';
import { PasswordLayoutProps } from '../Password';
import { Input } from 'shadcn-ui';
import ShadcnBaseInputLayout from '../../layout/ShadcnBaseInputLayout';

function ShadcnPasswordLayout(props: PasswordLayoutProps) {
  return (
    <ShadcnBaseInputLayout
      label={props.label}
      name={props.name}
      errors={props.errors}
      showLabel={props.showLabel}
      className={props.className}
      hideLabel={props.hideLabel}
      hint={props.hint}
    >
      <Input
        disabled={props.isDisabled}
        name={props.name}
        autoComplete="new-password"
        placeholder={props.placeholder}
        type="password"
        value={props.value || ''}
        onChange={props.onChangeCallback}
        onFocus={props.onFocusCallback}
        onBlur={props.onBlurCallback}
        data-lpignore="true"
      />
    </ShadcnBaseInputLayout>
  );
}

export default ShadcnPasswordLayout;
